// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const notifApi = createApi({
  reducerPath: "notifApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
  }),
  tagTypes: ["Notif"],
  endpoints: (builder) => ({
    getNotifByUser: builder.query<any, string>({
      query: (userId) => `notifications?userId=${userId}`,
      providesTags: ["Notif"],
    }),
    getCountNotifByUser: builder.query<any, string>({
      query: (userId) => `notifications/user/${userId}/count`,
      providesTags: ["Notif"],
    }),
    resetCountNotifByUser: builder.mutation<any, { userId: string }>({
      query: (body) => {
        return {
          url: `notifications/user/clearNotifications`,
          method: "post",
          body,
        };
      },
      invalidatesTags: ["Notif"],
    }),
    deleteNotifByUser: builder.mutation<any, string>({
      query: (notifId) => {
        return {
          url: `notifications/${notifId}`,
          method: "delete",
        };
      },
      invalidatesTags: ["Notif"],
    }),
    acceptNotificationOfInstaProf: builder.mutation<any, any>({
      query: (idNotif) => {
        return {
          url: `advertisements/instaProf/newRequest/accept`,
          method: "post",
          body: {
            id: idNotif,
          },
        };
      },
      invalidatesTags: ["Notif"],
    }),
    refuseSessionInstaProf: builder.mutation<any, any>({
      query: (idNotif) => {
        return {
          url: `advertisements/instaProf/newRequest/refuse`,
          method: "post",
          body: {
            id: idNotif,
          },
        };
      },
      invalidatesTags: ["Notif"],
    }),
    viewNotifByUser: builder.mutation<any, string>({
      query: (notifId) => {
        return {
          url: `/notifications/${notifId}`,
          method: "PATCH",
        };
      },
      invalidatesTags: ["Notif"],
    }),
    stopRequestInstaProf: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `advertisements/instaProf/newRequest/stop`,
          method: "post",
          body,
        };
      },
      invalidatesTags: ["Notif"],
    }),
    lastSessionInstaProf: builder.query<any, string>({
      query: (idNotif) => {
        return {
          url: `advertisements/instaProf/newRequest/student/show`,
          method: "post",
          body: {
            id: idNotif,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useRefuseSessionInstaProfMutation,
  useGetNotifByUserQuery,
  useGetCountNotifByUserQuery,
  useDeleteNotifByUserMutation,
  useViewNotifByUserMutation,
  useAcceptNotificationOfInstaProfMutation,
  useStopRequestInstaProfMutation,
  useLastSessionInstaProfQuery,
  useResetCountNotifByUserMutation,
} = notifApi;
